import localDB from "./localDB";

let GLOBAL = require('./globals');

const StoreProfileData = {
    async get() {
        const response = await fetch(`${GLOBAL.BASE_URL}api/store/invoice`, {
            method: 'GET',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': localDB.sessionToken()
            }
        });
        return await response.json();
    },
    async get_branch_office(id) {
        const response = await fetch(`${GLOBAL.BASE_URL}api/store/invoice/${id}`, {
            method: 'GET',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': localDB.sessionToken()
            }
        });
        return await response.json();
    },
    update(data, res) {
        fetch(`${GLOBAL.BASE_URL}api/store/invoice/${data.id}`, {
            method: 'PUT',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': localDB.sessionToken()
            },
            body: JSON.stringify(data)
        }).then((response) => response.json()).then((responseData) => {
            res(responseData);
        }).catch((err) => {
            res({update: false})
        });
    },
};

export default StoreProfileData;



// WEBPACK FOOTER //
// ./src/data/InvoiceData.js